import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'react-spreadsheet-grid';
import { fetchReportTestingSheetRequest } from '../redux/actions';
import { Typography } from '@mui/material';
import GridTitle from './GridTitle';
import GridTypography from './GridTypography';
import Loader from './Loader';

function ReportTestingSheet(props) {
    const { engagementCode, branchSubCode } = props;
    const dispatch = useDispatch();

    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([]);

    const { loading, data: reportTestingSheetDataSet, error } = useSelector((state) => state.reportTestingSheet);

    useEffect(() => {
        if (engagementCode && branchSubCode) {
            dispatch(fetchReportTestingSheetRequest(engagementCode, branchSubCode));
        }
    }, [branchSubCode, dispatch, engagementCode]);

    useEffect(() => {
        if (reportTestingSheetDataSet) {
            setRows(reportTestingSheetDataSet);
        }
    }, [reportTestingSheetDataSet]);

    const initColumns = () => {
        return [
            {
                title: () => {
                    return (
                        <GridTitle title="Document Number / Section Name - Same as in ADAT Index" tooltip="Document Number / Section Name - Same as in ADAT Index" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.section} tooltip={row.section} />
                    );
                },
                id: 'section',
            }, {
                title: () => {
                    return (
                        <GridTitle title="FS Notes - same as in TB" tooltip="FS Notes - same as in TB" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.fsnote} tooltip={row.fsnote} />
                    );
                },
                id: 'fsnote',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Combined Account Name" tooltip="Combined Account Name" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.combinedAccName} tooltip={row.combinedAccName} />
                    );
                },
                id: 'combinedAccName',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Preliminary" tooltip=" Sum of Preliminary" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.preliminary} tooltip={row.preliminary} />
                    );
                },
                id: 'preliminary',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of CJE" tooltip=" Sum of CJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.cjetotal} tooltip={row.cjetotal} />
                    );
                },
                id: 'cjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Sum of Adjusted" tooltip="Sum of Adjusted" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.adjusted} tooltip={row.adjusted} />
                    );
                },
                id: 'adjusted',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of GJE" tooltip=" Sum of GJE" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.gjetotal} tooltip={row.gjetotal} />
                    );
                },
                id: 'gjetotal',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Final" tooltip=" Sum of Final" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.final} tooltip={row.final} />
                    );
                },
                id: 'final',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Previous Year" tooltip=" Sum of Previous Year" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.pfy} tooltip={row.pfy} />
                    );
                },
                id: 'pfy',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Comparative 2" tooltip=" Sum of Comparative 2" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp2} tooltip={row.comp2} />
                    );
                },
                id: 'comp2',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Comparative 3" tooltip=" Sum of Comparative 3" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp3} tooltip={row.comp3} />
                    );
                },
                id: 'comp3',
            }, {
                title: () => {
                    return (
                        <GridTitle title=" Sum of Comparative 4" tooltip=" Sum of Comparative 4" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.comp4} tooltip={row.comp4} />
                    );
                },
                id: 'comp4',
            }
        ]
    };

    useEffect(() => {
        if (rows && rows.length > 0) {
            setColumns(initColumns());
        }
    }, [rows])

    return (
        <>
            {loading && <Loader />}
            {error && <Typography color="error">Error: {error}</Typography>}
            {columns && columns.length > 0 &&
                <Grid
                    columns={columns}
                    rows={rows}
                    getRowKey={row => row.tbId}
                    focusOnSingleClick={true}
                    isScrollable
                />
            }
        </>
    )
}

export default ReportTestingSheet;